import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const deleteOntBamFile = async (ontBamId) => {
  const { data } = await axios.delete(`${API_BASE_URL}/ont/${ontBamId}`)
  return data
}
